/* eslint-disable max-lines */
/* eslint-disable max-len */
/* eslint-disable no-invalid-this */
import ApiService, { PAYMENTS_API_CONTEXT, PAYMENTS_API_HOST } from './ApiService';

/**
 * @override
 */
class PaymentsService extends ApiService {
    /**
     * constructor
     */
    constructor() {
        super({ baseURL: PAYMENTS_API_HOST });
    }

    getTransactions = config => {
        return this.getList(`${PAYMENTS_API_CONTEXT}/transactions`, config);
    };

    getRemainingTransactions = config => {
        return this.get(`${PAYMENTS_API_CONTEXT}/transactions/remaining`, config);
    };

    getRemainingOperations = config => {
        return this.get(`${PAYMENTS_API_CONTEXT}/operations/remaining`, config);
    };

    getReconciliationInfo = (uuid_reconciliation, config) => {
        return this.getList(`${PAYMENTS_API_CONTEXT}/reconciliations/${uuid_reconciliation}`, config);
    };

    setConciliation = body => {
        return this.post(`${PAYMENTS_API_CONTEXT}/reconciliations`, body);
    };

    patchConciliation = (uuid_reconciliation, body) => {
        return this.patch(`${PAYMENTS_API_CONTEXT}/reconciliations/${uuid_reconciliation}`, body);
    };

    setNote = (uuidTransfer, payload) => {
        return this.patch(`${PAYMENTS_API_CONTEXT}/transactions/${uuidTransfer}`, payload);
    };

    getOperationsSuggested = body => {
        return this.post(`${PAYMENTS_API_CONTEXT}/operation-suggestions`, body);
    };

    getTransfersSuggested = body => {
        return this.post(`${PAYMENTS_API_CONTEXT}/transactions-suggestions`, body);
    };

    getTransfersPagination = (url, config) => {
        return this.get(url, config);
    };

    getOperationsPagination = (url, config) => {
        return this.get(url, config);
    };

    //
    //
    //
    // Métodos mockeados
    //  |||||||||||||||
    //  vvvvvvvvvvvvvvv
    //
    //

    getConciliation2Aggregation = () => {
        return this.get(`${PAYMENTS_API_CONTEXT}/reconciliations2/aggregation`);
    };

    getBankOperations = body => {
        return this.post(`${PAYMENTS_API_CONTEXT}/reconciliations2/bank-operations`, body);
    };

    createBankOperation = body => {
        return this.post(`${PAYMENTS_API_CONTEXT}/reconciliations2/bank-operation`, body);
    };

    createRDOperation = body => {
        return this.post(`${PAYMENTS_API_CONTEXT}/reconciliations2/rd-operation`, body);
    };

    loadRDOperations = body => {
        return this.post(`${PAYMENTS_API_CONTEXT}/reconciliations2/rd-operations`, body);
    };

    getReconciliation2Info = (uuid_reconciliation, config) => {
        return this.getList(`${PAYMENTS_API_CONTEXT}/reconciliations2/${uuid_reconciliation}`, config);
    };

    patchConciliation2 = (uuid_reconciliation, body) => {
        return this.patch(`${PAYMENTS_API_CONTEXT}/reconciliations2/${uuid_reconciliation}`, body);
    };

    setConciliation2 = body => {
        return this.post(`${PAYMENTS_API_CONTEXT}/reconciliations2`, body);
    };

    getHistoricConciliaion2 = body => {
        return this.post(`${PAYMENTS_API_CONTEXT}/reconciliations2/historic-reconciliations2`, body);
    };

    conciliation2RDSync = () => {
        return this.get(`${PAYMENTS_API_CONTEXT}/reconciliations2/rd-sync`);
    }

}

const paymentsService = new PaymentsService();

export default paymentsService;
